module.exports = __webpack_public_path__ + "assets/img/footer-blob-bottom.1e25ca97.png";